import './FilterItem.scss';

import React, { Component } from 'react';

import { DashboardConfig } from '../../config/kyvDashboard';
import { DashboardList } from '../../config/dashboards';
import { DataLoader } from '../../ui-components/DataLoader/DataLoader';
import { DbrdUtils } from '../../chart-components/ChartUtils/DbrdUtils';
import Dropdown from '../DropDown/Dropdown';
import { MapToolButton } from '../MapToolButton/MapToolButton';
import PropTypes from 'prop-types';
import { TimeUtils } from '../../chart-components/ChartUtils/TimeUtils';
import olGeoJSON from 'ol/format/GeoJSON';
import olWKT from 'ol/format/WKT';
import { selectableLayers } from '../Map/selectableLayers';
import withRouter from '../../hocs/withRouter';

class FilterItemBase extends Component {

  static propTypes = {
    dashboard: PropTypes.string.isRequired,
    filter: PropTypes.object.isRequired,
    passlines: PropTypes.array.isRequired,
    municipalities: PropTypes.array.isRequired,
    setFilter: PropTypes.func.isRequired,
    setMapInteraction: PropTypes.func.isRequired,
    interactionType: PropTypes.string,
    loadData: PropTypes.func.isRequired,
    numGeom: PropTypes.number.isRequired
  };

  static defaultProps = {
    numGeom: 1
  }

  // GeoJSON format function
  _geoJsonFmt = new olGeoJSON();

  // WKT format function
  _wktFmt = new olWKT();

  constructor(props) {
    super(props);

    var dbrdSettings = null;
    var dbrdClass = DashboardList[this.props.dashboard][0];
    if (DbrdUtils.isDashboard(dbrdClass)) {
      dbrdSettings = dbrdClass.dashboardSettings();
    }

    this.state = {
      filter: props.filter,
      lastUpdatedMessage: '',
      filterControls: dbrdSettings ? dbrdSettings.filterControls : undefined,
      selectableLayer: dbrdSettings ? dbrdSettings.selectableLayer : undefined
    };

    this.renderButtons = this.renderButtons.bind(this);
    this.loadDashboard = this.loadDashboard.bind(this);
    this.isValid = this.isValid.bind(this);
    this.onMcpSelected = this.onMcpSelected.bind(this);
    this.onMcpCleared = this.onMcpCleared.bind(this);
    this.onLocByMcpSelected = this.onLocByMcpSelected.bind(this);
    this.onLocByMcpCleared = this.onLocByMcpCleared.bind(this);
    this.onPasslineSelected = this.onPasslineSelected.bind(this);
    this.onPasslineCleared = this.onPasslineCleared.bind(this);
    this.onPasslineSave = this.onPasslineSave.bind(this);
    this.onPasslineDelete = this.onPasslineDelete.bind(this);
  }

  componentDidMount() {
    this.loadMetaInventory();
  }

  componentWillUnmount() {

  }

  loadMetaInventory() {
    DataLoader.postApi('/api/meta/most-recent', {}).then(response => {
      var updated = response.data.map(d => {
        var dataset = '';
        if (['ais', 'nsr'].indexOf(d.dataset) > -1) {
          if (d.dataset === 'ais') {
            dataset = 'AIS data (posisjoner, "skipshaler"/tracks)';
          } else if (d.dataset === 'nsr') {
            dataset =
              'NewShipRep data (skipsinformasjon, havner, seilas, avganger, ankomster, lospliktige seilas)';
          }
          return `Nyeste tilgjengelige ${dataset}: ${TimeUtils.toCompactDate(new Date(d.newest))}`;
        } else {
          return null;
        }
      });
      this.setState({
        lastUpdatedMessage: updated.join('. ')
      });
    });
  }

  onMcpSelected(selMcps) {
    const { municipalities, setFilter } = this.props;
    var selMunicipIDs = selMcps.map(s => s.value);
    setFilter({
      municipalities: selMcps,
      geom: municipalities.filter(mcp => selMunicipIDs.indexOf(mcp.properties.komm) > -1).map(m => this._wktFmt.writeFeature(this._geoJsonFmt.readFeature(m)))
    });
  }

  onMcpCleared() {
    const { setFilter } = this.props;
    setFilter({
      'municipalities': null,
      'geom': null
    });
  }

  onPasslineSelected(selectedPassline) {
    const { setFilter, passlines } = this.props;
    setFilter({
      'passline': selectedPassline.value,
      'geom': passlines.filter(pln => pln && pln.properties.id === selectedPassline.value.id).map(p => this._wktFmt.writeFeature(this._geoJsonFmt.readFeature(p)))
    });
  }

  onPasslineCleared() {
    const { setFilter } = this.props;
    setFilter({
      'passline': undefined,
      'geom': undefined
    });
  }

  onPasslineSave() {
    const { filter, loadData } = this.props;
    var title = prompt('Oppgi navn for passeringslinjen?');
    if (title && filter && Array.isArray(filter.geom) && filter.geom.length > 0) {
      DataLoader.savePassline(filter.geom[0], title).then(wsRes => {
        if (Array.isArray(wsRes) && wsRes.length > 0) {
          var newPasslineIds = wsRes.filter(d => d.key === 'record').map(d => d.value.id);
          if (newPasslineIds.length > 0) {
            loadData(selectableLayers.passlines);
          }
        }
      });
    }
  }

  onPasslineDelete() {
    const { filter, loadData, setFilter } = this.props;
    if (filter.passline.visibility === true && window.confirm('Er du sikker på at du vil slette passeringslinjen?')) {
      DataLoader.deletePassline(filter.passline.id).then(res => {
        if (res.success !== true) {
          console.debug('Error deleting passline', filter.passline, res);
        }
        loadData(selectableLayers.passlines);
      });
      setFilter({
        passline: undefined,
        geom: undefined
      });
    }
  }

  onLocByMcpSelected(selMcps) {
    const { municipalities, setMapInteraction, setFilter } = this.props;

    var selMunicipIDs = selMcps.map(s => s.value);
    var selMunicipGeoms = municipalities.filter(m => selMunicipIDs.indexOf(m.properties.komm) > -1);

    setFilter({
      'municipalities': selMcps,
      'geom': selMunicipGeoms.map(m => this._wktFmt.writeFeature(this._geoJsonFmt.readFeature(m)))
    });

    // Note, passing data in EPSG:3857 to overlay method!
    setMapInteraction('overlayPolygon', selectableLayers.locationIds, selMunicipGeoms);
  }

  onLocByMcpCleared() {
    const { setFilter } = this.props;

    setFilter({
      'municipalities': null,
      'geom': null,
      'locationIds': null
    });
  }

  /**
   * Add filter controls for current dashboard if any are indicated in the config file
   */
  renderButtons() {
    var controls = [];
    const { municipalities, passlines, setMapInteraction, filter, interactionType, setFilter, numGeom } = this.props;

    const { filterControls, selectableLayer } = this.state;

    if (Array.isArray(filterControls) && filterControls.length > 0) {
      // Select municipality dropdown
      if (filterControls.indexOf(DashboardConfig.filterControls.municipality) > -1 && Array.isArray(municipalities) && (!selectableLayer || selectableLayer === selectableLayers.municipalities)) {
        controls.push(
          <Dropdown
            label='Velg Kommune(r):'
            key={'fc-select-municipality'}
            items={municipalities.map(m => {
              return { label: m.properties.name, value: m.properties.komm };
            })}
            placeholder='Kommunenavn'
            onSelect={this.onMcpSelected}
            onClear={this.onMcpCleared}
            isMulti
            value={filter.municipalities}
          />
        );
      }

      // Select passline dropdown
      if (filterControls.indexOf(DashboardConfig.filterControls.passline) > -1 && Array.isArray(passlines) && (selectableLayer === selectableLayers.passlines)) {
        controls.push(
          <Dropdown
            label='Velg passeringslinje'
            key={'fc-select-passlines'}
            items={passlines.map(passline => {
              return {
                'value': passline.properties,
                'label': passline.properties.name
              };
            })}
            placeholder='Passeringslinjenavn'
            onSelect={this.onPasslineSelected}
            onClear={this.onPasslineCleared}
            value={filter.passline}
          />
        );
        // TODO: add better test for passline to see if own or shared
        if (filter.geom && filter.passline && filter.passline.visibility === true) {
          controls.push(
            <div className='filter-container--map-btn-w-label' key='fc-select-passlines-delete'>
              <MapToolButton
                label='Slett egendefinert passeringslinje'
                onClick={this.onPasslineDelete}
              />
            </div>
          );
        }
      }

      // Select locationIDs by municipality dropdown
      if (filterControls.indexOf(DashboardConfig.filterControls.municipality) > -1 && Array.isArray(municipalities) && selectableLayer === selectableLayers.locationIds) {
        controls.push(
          <Dropdown
            label='Velg lokasjoner i kommune(r):'
            key={'fc-select-municipality-location-ids'}
            items={municipalities.map(m => {
              return { label: m.properties.name, value: m.properties.komm };
            })}
            placeholder='Kommunenavn'
            onSelect={this.onLocByMcpSelected}
            onClear={this.onLocByMcpCleared}
            isMulti
            value={filter.municipalities}
          />
        );
      }

      // Add draw point interaction
      if (filterControls.indexOf(DashboardConfig.filterControls.drawPoint) > -1) {
        controls.push(
          <div className='filter-container--map-btn-w-label' key='fc-draw-point'>
            <label>eller...</label>
            <MapToolButton
              label='Tegn punkt'
              className={interactionType === DashboardConfig.filterControls.drawPoint ? 'map-btn-active' : ''}
              onClick={() => {
                this.onMapInteractionBtnClick(DashboardConfig.filterControls.drawPoint);
                setMapInteraction(DashboardConfig.filterControls.drawPoint, null, null, numGeom);
              }}
            />
          </div>
        );
      }

      // Add draw line interaction
      if (filterControls.indexOf(DashboardConfig.filterControls.drawLine) > -1 && selectableLayer !== selectableLayers.passlines) {
        controls.push(
          <div className='filter-container--map-btn-w-label' key='fc-draw-line'>
            <label>eller...</label>
            <MapToolButton
              label='Tegn linje'
              className={interactionType === DashboardConfig.filterControls.drawLine ? 'map-btn-active' : ''}
              onClick={() => {
                this.onMapInteractionBtnClick(DashboardConfig.filterControls.drawLine);
                setMapInteraction(DashboardConfig.filterControls.drawLine, null, null, numGeom);
              }}
            />
          </div>
        );
      }

      // Add draw passline interaction
      if (filterControls.indexOf(DashboardConfig.filterControls.drawLine) > -1 && selectableLayer === selectableLayers.passlines) {
        controls.push(
          <div className='filter-container--map-btn-w-label' key='fc-draw-line-passline'>
            <label>eller...</label>
            <MapToolButton
              label='Tegn passeringslinje'
              className={interactionType === DashboardConfig.filterControls.drawLine ? 'map-btn-active' : ''}
              onClick={() => {
                this.onMapInteractionBtnClick(DashboardConfig.filterControls.drawLine);
                setFilter({ passline: undefined, geom: undefined });
                setMapInteraction(DashboardConfig.filterControls.drawLine, selectableLayers.passlines, null, numGeom);
              }}
            />
          </div>
        );
        if (filter.geom) {
          controls.push(
            <div className='filter-container--map-btn-w-label' key='fc-draw-line-passline-save'>
              <MapToolButton
                label='Lagre passeringslinje'
                className={interactionType === DashboardConfig.filterControls.drawLine ? 'map-btn-active' : ''}
                onClick={this.onPasslineSave}
              />
            </div>
          );
        }
      }

      // Add draw polygon interaction
      if (filterControls.indexOf(DashboardConfig.filterControls.drawPolygon) > -1) {
        controls.push(
          <div className='filter-container--map-btn-w-label' key='fc-draw-polygon'>
            <label>eller...</label>
            <MapToolButton
              label='Tegn flate'
              className={
                interactionType === DashboardConfig.filterControls.drawPolygon ? 'map-btn-active' : ''
              }
              onClick={() => {
                this.onMapInteractionBtnClick(DashboardConfig.filterControls.drawPolygon);
                setMapInteraction(DashboardConfig.filterControls.drawPolygon, null, null, numGeom);
              }}
            />
          </div>
        );
      }

      // Add draw box interaction
      if (filterControls.indexOf(DashboardConfig.filterControls.drawBox) > -1) {
        controls.push(
          <div className='filter-container--map-btn-w-label' key='fc-draw-box'>
            {/* <label>eller...</label> */}
            <MapToolButton label='Tegn rektangel'
              className={interactionType === DashboardConfig.filterControls.drawBox ? 'map-btn-active' : ''}
              onClick={() => {
                this.onMapInteractionBtnClick(DashboardConfig.filterControls.drawBox);
                setMapInteraction(DashboardConfig.filterControls.drawBox, null, null, numGeom);
              }}
            />
          </div>
        );
      }

      // Select locatoinIDs by point
      if (filterControls.indexOf(DashboardConfig.filterControls.selectPoint) > -1 && selectableLayer === selectableLayers.locationIds) {
        controls.push(
          <div className='filter-container--map-btn-w-label' key='fc-select-point-location-ids'>
            <label>eller...</label>
            <MapToolButton
              label='Velg lokasjon(er) i kart'
              className={
                interactionType === DashboardConfig.filterControls.selectPoint ? 'map-btn-active' : ''
              }
              onClick={() => {
                this.onMapInteractionBtnClick(DashboardConfig.filterControls.selectPoint);
                setMapInteraction(DashboardConfig.filterControls.selectPoint, selectableLayers.locationIds, null, 100);
              }}
            />
          </div>
        );
      }

      // Select location IDs by polygon
      if (filterControls.indexOf(DashboardConfig.filterControls.selectPolygon) > -1 && selectableLayer === selectableLayers.locationIds) {
        controls.push(
          <div className='filter-container--map-btn-w-label' key='fc-select-polygon-location-ids'>
            <label>eller...</label>
            <MapToolButton
              label='Velg lokasjon(er) innen flate'
              className={
                interactionType === DashboardConfig.filterControls.selectPolygon ? 'map-btn-active' : ''
              }
              onClick={() => {
                this.onMapInteractionBtnClick(DashboardConfig.filterControls.selectPolygon);
                setMapInteraction(DashboardConfig.filterControls.selectPolygon, selectableLayers.locationIds, null, numGeom);
              }}
            />
          </div>
        );
      }

      // Select location IDs by box
      if (filterControls.indexOf(DashboardConfig.filterControls.selectBox) > -1 && selectableLayer === selectableLayers.locationIds) {
        controls.push(
          <div className='filter-container--map-btn-w-label' key='sblfc-select-box-location-ids'>
            <label>eller...</label>
            <MapToolButton
              label='Velg lokasjon(er) innen rektangel'
              className={
                interactionType === DashboardConfig.filterControls.selectBox ? 'map-btn-active' : ''
              }
              onClick={() => {
                this.onMapInteractionBtnClick(DashboardConfig.filterControls.selectBox);
                setMapInteraction(DashboardConfig.filterControls.selectBox, selectableLayers.locationIds, null, numGeom);
              }}
            />
          </div>
        );
      }

      // Select passlines by point
      if (filterControls.indexOf(DashboardConfig.filterControls.selectPoint) > -1 && selectableLayer === selectableLayers.passlines) {
        controls.push(
          <div className='filter-container--map-btn-w-label' key='fc-select-polygon-passlines'>
            <label>eller...</label>
            <MapToolButton
              label={'Velg passeringslinje i kart'}
              className={
                interactionType === DashboardConfig.filterControls.selectPoint ? 'map-btn-active' : ''
              }
              onClick={() => {
                this.onMapInteractionBtnClick(DashboardConfig.filterControls.selectPoint);
                setMapInteraction(DashboardConfig.filterControls.selectPoint, selectableLayers.passlines, null, numGeom);
              }}
            />
          </div>
        );
      }
    }
    return controls;
  }

  onMapInteractionBtnClick(interactionType) {
    const { setFilter } = this.props;

    setFilter({
      geom: undefined,
      municipalities: undefined,
      locationIds: undefined
    });

    this.setState({
      interactionType
    });
  }

  loadDashboard() {
    const { dashboard, filter, navigate } = this.props;
    var dbrdRoute = `/tallogstatistikk/${dashboard}/dashboard`;
    navigate(dbrdRoute, {
      state: filter
    })
  }

  isValid() {
    const { dashboard, filter } = this.props;

    let dbrdClass = DashboardList[dashboard][0];
    if (DbrdUtils.isDashboard(dbrdClass)) {
      return dbrdClass.dashboardValidation(filter);
    } else {
      console.debug(`There is still a dashboard (${dashboard}) that does not have embedded validation, will never validate`);
      return false;
    }
  }

  render() {
    const { dashboard, passlines, setFilter } = this.props;
    const { lastUpdatedMessage, filter } = this.state;
    let helpMessage;

    if (!Array.isArray(passlines)) {
      return (<div>Loading</div>);
    }

    var controls = [];

    var dbrdClass = DashboardList[dashboard][0];
    if (DbrdUtils.isDashboard(dbrdClass)) {
      var dbrdFilters = dbrdClass.dashboardFilters(filter, setFilter, passlines, (a) => { console.debug('Calling redundant function', a); });
      helpMessage = dbrdFilters.helpMessage;
      controls = controls.concat(dbrdFilters.controls);
    } else {
      // console.log(DashboardList[dashboard]);
      // TODO: Remove linline render/debug function
      console.error(`The dashboard ${dbrdClass && dbrdClass.name} does not render filters based on embedded method`);
    }

    return (
      <div className='filter-toolbar'>
        <p>{helpMessage}</p>
        <p>{lastUpdatedMessage}</p>
        {controls}
        {this.renderButtons()}
        <button
          className='filter-container--submit-btn'
          disabled={!this.isValid()}
          onClick={this.loadDashboard}
        >
          Åpne dashboard
        </button>
      </div>
    );
  }
}

export const FilterItem = withRouter(FilterItemBase)

export default FilterItem; 